import axios from "axios";

import type { SourceAttribute } from "@/hooks/useMovementsTable";

export type SubsourceCustomDownload = {
  _id: string;
  name: string;
};

export type Subsource = {
  _id: string;
  name: string;
  sourceColumns: SourceAttribute[];
  customDownloads?: SubsourceCustomDownload[];
  sourceId: string;
  tenantId: string;
  source: {
    _id: string;
    persistentMovements: boolean;
    name?: string;
  };
};

export type SubsourceDisplayAttrs = string[][];

export type Step = {
  _id: string;
  name: string;
  subsourceDisplayAttrs: SubsourceDisplayAttrs;
  subsourceSumAttrs: string[];
  subsources: Subsource[];
};

export type Group = {
  _id: string;
  name: string;
  subsources: Subsource[];
  steps: Step[];
};

type RawSubsource = Omit<Subsource, "sourceColumns"> & {
  sourceColumns?: SourceAttribute[] | null;
};

type RawStep = Omit<Step, "subsources"> & {
  subsources: RawSubsource[];
};

type RawGroup = Omit<Group, "subsources" | "steps"> & {
  subsources: RawSubsource[];
  steps: RawStep[];
};

function normalizeSubsource(subsource: RawSubsource): Subsource {
  return {
    ...subsource,
    sourceColumns: subsource.sourceColumns ?? [],
  };
}

function normalizeGroup(group: RawGroup): Group {
  return {
    ...group,
    subsources: group.subsources.map(normalizeSubsource),
    steps: group.steps.map((step) => ({
      ...step,
      subsources: step.subsources.map(normalizeSubsource),
    })),
  };
}

export const fetchGroups = async () => {
  const { data } = await axios.get<{ status: string; data: RawGroup[] }>(
    "/tables/group",
  );

  return {
    ...data,
    data: data.data.map(normalizeGroup),
  };
};
